<div class="med-checkbox-group">
  <med-checkbox
    *ngFor="let option of options"
    [size]="size"
    [label]="option.label"
    [labelClass]="labelClass"
    [disabled]="disabled || option.disabled"
    [required]="option.required"
    [value]="hasValue(option.value)"
    class="med-checkbox-group__item"
    (change)="onChangeHandler($event, option)"
  ></med-checkbox>
</div>

<div
  *ngIf="invalid"
  class="field__error-message"
>
  {{ errorMessage }}
</div>
